import ufeApi from 'services/api/ufeApi';

function getAbTestTrendingOffers(token, { abTestId, deviceId, abTestEndDate }) {
    const url = `/gway/v1/abtest-service/personalization/banners?abTestId=${abTestId}&deviceId=${deviceId}&abTestEndDate=${encodeURIComponent(abTestEndDate)}`;

    const headers = {
        Authorization: `Bearer ${token}`
    };

    return ufeApi.makeRequest(url, { method: 'GET', headers }).then(data => data);
}

export default getAbTestTrendingOffers;
